import { Spinner } from '../ui/Spinner.jsx';
import styles from './PageLoader.module.css';

/** Full-page loading state used as the Suspense fallback for lazy routes. */
export function PageLoader({ label = 'Loading' }) {
  return (
    <div className={styles.container}>
      <Spinner size={32} label={label} />
    </div>
  );
}
